import { render } from "./_Permissao.vue?vue&type=template&id=5b96ef03&scoped=true"
import script from "./_Permissao.vue?vue&type=script&lang=ts"
export * from "./_Permissao.vue?vue&type=script&lang=ts"

import "./_Permissao.vue?vue&type=style&index=0&id=5b96ef03&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5b96ef03"

export default script